import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { Tooltip } from "react-tooltip";
import Link from "next/link";
import Image from "next/image";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { WAVE_VOTING_LABELS, WAVE_VOTE_STATS_LABELS } from "@/helpers/waves/waves.constants";
import type { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
interface WaveLeaderboardDropRatersProps {
  readonly drop: ExtendedDrop;
}
export const WaveLeaderboardDropRaters: React.FC<WaveLeaderboardDropRatersProps> = t0 => {
  const $ = _c(46);
  const {
    drop
  } = t0;
  const votersCountLabel = drop.raters_count === 1 ? "voter" : "voters";
  const userVote = drop.context_profile_context?.rating ?? 0;
  const isNegativeVote = userVote < 0;
  const votingLabel = WAVE_VOTING_LABELS[drop.wave.voting_credit_type as ApiWaveCreditType];
  let t1;
  if ($[0] !== drop.rank || $[1] !== isNegativeVote) {
    const topThreeRankStyles = {
      1: "tw-text-[#E8D48A]",
      2: "tw-text-[#DDDDDD]",
      3: "tw-text-[#CD7F32]"
    };
    const getRankStyle = () => {
      if (drop.rank && drop.rank <= 3) {
        return topThreeRankStyles[drop.rank];
      }
      if (isNegativeVote) {
        return "tw-bg-gradient-to-r tw-from-red tw-to-red tw-bg-clip-text tw-text-transparent";
      }
      return "tw-bg-gradient-to-r tw-from-emerald-400 tw-to-emerald-500 tw-bg-clip-text tw-text-transparent";
    };
    t1 = getRankStyle();
    $[0] = drop.rank;
    $[1] = isNegativeVote;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rankStyle = t1;
  const hasUserVoted = drop.context_profile_context?.rating !== undefined && drop.context_profile_context?.rating !== 0;
  const t2 = `tw-text-sm tw-font-semibold ${rankStyle}`;
  let t3;
  if ($[3] !== drop.rating) {
    t3 = formatNumberWithCommas(drop.rating);
    $[3] = drop.rating;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== drop.rating || $[9] !== drop.rating_prediction) {
    t5 = <DropVoteProgressing current={drop.rating} projected={drop.rating_prediction} />;
    $[8] = drop.rating;
    $[9] = drop.rating_prediction;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="tw-relative tw-inline-flex tw-items-center tw-gap-x-1">{" "}{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== votingLabel) {
    t7 = <span className="tw-text-iron-400 tw-text-sm tw-whitespace-nowrap">{votingLabel} {WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
    $[14] = votingLabel;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="tw-flex tw-items-baseline tw-gap-x-1">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== drop.id || $[20] !== drop.top_raters || $[21] !== votingLabel) {
    let t10;
    if ($[23] !== drop.id || $[24] !== drop.top_raters.length || $[25] !== votingLabel) {
      t10 = (voter, index) => <React.Fragment key={voter.profile.id}><div className="tw-relative tw-transition-transform hover:tw-scale-110 hover:tw-z-10" style={{
          zIndex: drop.top_raters.length - index
        }} data-tooltip-id={`voter-${drop.id}-${voter.profile.id}`}><Link href={`/${voter.profile.handle}`}>{voter.profile.pfp ? <Image src={resolveIpfsUrlSync(getScaledImageUri(voter.profile.pfp, ImageScale.W_AUTO_H_50))} alt={`${voter.profile.handle}'s Profile`} width={20} height={20} className="tw-h-5 tw-w-5 tw-rounded-md tw-ring-1 tw-ring-black tw-bg-iron-800 tw-object-contain" /> : <div className="tw-h-5 tw-w-5 tw-rounded-md tw-ring-1 tw-ring-black tw-bg-iron-800" />}</Link></div><Tooltip id={`voter-${drop.id}-${voter.profile.id}`} delayShow={0} style={{
          backgroundColor: "#1F2937",
          color: "white",
          padding: "4px 8px",
          zIndex: 1000
        }}><span className="tw-text-sm tw-font-medium">{voter.profile.handle} •{" "}{formatNumberWithCommas(voter.rating)}{" "}{votingLabel}</span></Tooltip></React.Fragment>;
      $[23] = drop.id;
      $[24] = drop.top_raters.length;
      $[25] = votingLabel;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    t9 = drop.top_raters.map(t10);
    $[19] = drop.id;
    $[20] = drop.top_raters;
    $[21] = votingLabel;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[27] !== t9) {
    t10 = <div className="tw-flex -tw-space-x-1.5 tw-items-center">{t9}</div>;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== drop.raters_count) {
    t11 = formatNumberWithCommas(drop.raters_count);
    $[29] = drop.raters_count;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== votersCountLabel) {
    t12 = <span className="tw-text-sm tw-text-iron-400">{t11} {votersCountLabel}</span>;
    $[31] = t11;
    $[32] = votersCountLabel;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t12) {
    t13 = <div className="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap">{t10}{t12}</div>;
    $[34] = t10;
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== hasUserVoted || $[38] !== rankStyle || $[39] !== userVote || $[40] !== votingLabel) {
    t14 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-1.5"><span className="tw-text-sm tw-whitespace-nowrap"><span className="tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}: </span><span className={`tw-font-semibold ${rankStyle}`}>{formatNumberWithCommas(userVote)} {votingLabel}</span></span></div>;
    $[37] = hasUserVoted;
    $[38] = rankStyle;
    $[39] = userVote;
    $[40] = votingLabel;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t13 || $[43] !== t14 || $[44] !== t8) {
    t15 = <div className="tw-flex tw-items-center tw-flex-wrap tw-gap-x-4 tw-gap-y-2 sm:tw-justify-end">{t8}{t13}{t14}</div>;
    $[42] = t13;
    $[43] = t14;
    $[44] = t8;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  return t15;
};